import { PayloadAction } from '@reduxjs/toolkit';

import { GangSheetState } from 'editor/src/store/gangSheet/types';

const setMarginMmReducer = (state: GangSheetState, action: PayloadAction<number>) => {
  state.marginMm = action.payload;
};

export default setMarginMmReducer;
